module.exports = __webpack_public_path__ + "img/Unicom-4.e8a9a5f2.svg";